import { Check } from "lucide-react";
import { BRAND, ASSOCIATIONS } from "@/data/content";
import { resolveAssetPath } from "@/lib/assets";

export const About = () => {
  return (
    <section
      id="about"
      data-testid="about-section"
      className="bg-[var(--soft)] py-14 border-y border-gray-200"
    >
      <div className="max-w-[1280px] mx-auto px-4 lg:px-6 grid grid-cols-1 lg:grid-cols-12 gap-10 items-center">
        <div className="lg:col-span-5">
          <div className="relative rounded-xl overflow-hidden aspect-[4/3] shadow-lg">
            <img
              src={resolveAssetPath("/assets/media/030-images-unsplash-com-photo-1564507592333-c60657eea523.jpg")}
              alt="Taj Mahal"
              className="w-full h-full object-cover"
            />
          </div>
        </div>

        <div className="lg:col-span-7">
          <div className="text-[var(--red)] font-semibold text-[11px] tracking-[0.25em] mb-2">
            ABOUT THE COMPANY
          </div>
          <h2 className="font-serif-display text-4xl md:text-5xl text-[var(--navy)] leading-tight">
            A luxury travel house,
            <br className="hidden md:block" />
            <span className="text-[var(--yellow-2)]">based in India.</span>
          </h2>
          <p className="text-gray-700 mt-5 text-sm md:text-base leading-relaxed max-w-2xl">
            Welcome to <span className="font-semibold">{BRAND.name}</span> —
            where we transform your travel dreams into unparalleled
            experiences. Established in March 2010, our journey has been one of
            continuous dedication to delivering top-notch services in the realm
            of travel and tourism.
          </p>
          <p className="text-gray-700 mt-3 text-sm md:text-base leading-relaxed max-w-2xl">
            We are proud members of esteemed travel associations and hold
            affiliations with India's foremost tourism authorities.
          </p>

          <div className="mt-7">
            <div className="text-[var(--navy)] font-semibold text-sm mb-3">
              Memberships & Affiliations
            </div>
            <ul className="grid grid-cols-1 sm:grid-cols-2 gap-2.5">
              {ASSOCIATIONS.map((a) => (
                <li
                  key={a}
                  data-testid={`assoc-${a.toLowerCase().replace(/[^a-z]/g, "")}`}
                  className="flex items-start gap-2 text-sm text-gray-700"
                >
                  <span className="w-5 h-5 rounded-full bg-[var(--yellow)] flex items-center justify-center mt-0.5 shrink-0">
                    <Check className="w-3 h-3 text-[var(--navy)]" strokeWidth={3} />
                  </span>
                  <span>{a}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};
